/* eslint-disable no-unused-vars */

/**
 *  Load modules
 */
import './modules/main';
import './modules/equal-height';
import tilesSlider from "./modules/tilesSlider";
import slickSliders from "./modules/slickSliders";
import overlapBlock from "./modules/overlapBlock";
import hero from "./modules/hero";
import spaceBlock from "./modules/space-block";
import expandBlock from "./modules/expander";
import getCookie from "./modules/cookie";
import showReel from "./modules/showreel"; // import videoPlay from "./modules/videoPlay";

import pdfSlider from "./modules/pdfSlider"; // import './modules/iconsGridRender';

import '../scss/app.scss'; // import {equalHeight} from "./modules/equal-height";

$(document).ready(function () {
  showReel(); // Touch Device Detection

  var isTouchDevice = ('ontouchstart' in document.documentElement);

  if (isTouchDevice) {
    $('body').addClass('touch');
  }

  tilesSlider();
  slickSliders();
  overlapBlock('.main');
  overlapBlock('.modal');
  hero();
  spaceBlock('body'); // spaceBlock('.modal');

  expandBlock(); //adding ids to elements

  $(".main > div").each(function (i) {
    $(this).attr('id', 'section-' + (i + 1));
  }); // scroll to the section

  setTimeout(function () {
    $(".btn[data-anchor]").click(function (e) {
      e.preventDefault();
      var sectionID = $(this).data('anchor');
      $('html, body').animate({
        scrollTop: $("#" + sectionID).offset().top
      }, 2000);
    });
  }, 100); // scroll to the section on different page

  function getParameters(name) {
    if (name = new RegExp('[?&]' + encodeURIComponent(name) + '=([^&]*)').exec(location.search)) return decodeURIComponent(name[1]);
  }

  var scrollToSection = getParameters('scrollToSection');

  if (scrollToSection) {
    setTimeout(function () {
      document.getElementById(scrollToSection).scrollIntoView();
    }, 100);
  }

  $('.hamburger').click(function () {
    $('.header').toggleClass('nav-active');
    $('body').toggleClass('nav-active');
  });
  $(window).on('resize orientationchange', function () {
    if (window.matchMedia("(min-width: 961px)").matches) {
      $('.header').removeClass('nav-active');
      $('body').removeClass('nav-active');
    }
  });
  $('.to_top').click(function (e) {
    e.preventDefault();
    $('html,body').animate({
      scrollTop: 0
    }, 'slow');
    return false;
  });
  var str = $(".single-projekte p");
  jQuery.each(str, function () {
    var html = $(this).html();

    if (html.indexOf("img") >= 0) {
      $(this).addClass('full');
    }
  });
  var isResizeble = false;
  $(".active_filter").click(function (e) {
    e.preventDefault();
    var active_element = $(".year li.active");
    var list_content = $(".active_list");
    $(this).toggleClass('active');
    $(".filter_posts").slideToggle();
    list_content.toggleClass('active');

    if (list_content.hasClass('active')) {
      list_content.html('');
    }

    if (isResizeble) {
      $.each(active_element, function () {
        var name = $(this).html();

        if ($(this)[0].hasAttribute('data-client')) {
          var client = $(this).data('client');
          list_content.append(renderFilter(name, 'data-client', client));
        } else if ($(this)[0].hasAttribute('data-tag')) {
          var tag = $(this).data('tag');
          list_content.append(renderFilter(name, 'data-tag', tag));
        }
      });
    }

    isResizeble = false;
    $('.active_list li').click(function () {
      var dataClient = $(this).data('client');
      var dataTag = $(this).data('tag');
      $(this).remove();

      if (dataClient) {
        $(".year li[data-client='" + dataClient + "']").trigger('click');
      } else if (dataTag) {
        $(".year li[data-tag='" + dataTag + "']").trigger('click');
      }
    });
  });

  function renderFilter(name, attrName, attrValue) {
    return "<li ".concat(attrName, "=\"").concat(attrValue, "\">").concat(name, "</li>");
  }

  $(window).on('load', function () {
    var queryString = window.location.search.substring(1);

    if (queryString) {
      $(".year li[data-tag='" + queryString + "']").trigger('click');
      var active_element = $(".year li.active");
      var list_content = $(".active_list");
      var $el = active_element.clone();
      list_content.html($el);
    }
  });
  $(".year li").click(function () {
    isResizeble = true;
    var list_content = $(".active_list");

    if ($(this).parent().hasClass('single-choice')) {
      $(this).siblings().removeClass('active');
    }

    $(this).toggleClass('active');
    var client = '';
    var tag = '';
    var item = $(".filter_posts li.active");
    $.each(item, function () {
      var dataClient = $(this).data('client');
      var dataTag = $(this).data('tag'); // console.log(dataClient);

      if (dataClient) {
        client = dataClient;
      }

      if (dataTag) {
        tag += dataTag + ',';
      }
    });
    var data = {
      'action': 'filter_post_asb',
      'client': client,
      'tag': tag.slice(0, -1)
    }; // console.log(data);

    $.ajax({
      url: "/wp-admin/admin-ajax.php",
      data: data,
      type: 'POST',
      success: function success(data) {
        $(".projects_filtered .row").html(data);
      }
    });
  });
  $(".year li.active").click(function () {
    $(this).removeClass('active');
  });
  $(document).on('click', '.accordion .item-title', function (e) {
    var $this = $(this);

    if (!$this.hasClass("active")) {
      $this.parents(".accordion").find(".collapse").slideUp(700);
      $this.parents(".accordion").find(".item-title").removeClass("active");
    }

    $this.toggleClass("active");
    $this.next().slideToggle(400);

    if ($this.hasClass("active")) {
      setTimeout(function () {
        $('body, html').animate({
          scrollTop: $this.offset().top - 15
        }, 800);

        if ($('.modal').length) {
          var scrollTopModal = $('.modal').scrollTop();
          var dist = $this.offset().top - $('.modal').offset().top;
          $('.modal').animate({
            scrollTop: scrollTopModal + dist - 15
          }, 800);
        }
      }, 700);
    }
  });

  function bigImage() {
    if ($(window).width() <= 767) {
      if ($(".big_image .image_mobile").length > 0) {
        $(".big_image .image_mobile").show().siblings().hide();
      } else if ($(".big_image .image_tablet").length > 0) {
        $(".big_image .image_tablet").show().siblings().hide();
      } else {
        $(".big_image .image_desktop").show().siblings().hide();
      }
    } else if ($(window).width() <= 1024) {
      if ($(".big_image .image_tablet").length > 0) {
        $(".big_image .image_tablet").show().siblings().hide();
      } else {
        $(".big_image .image_desktop").show().siblings().hide();
      }
    } else {
      $(".big_image .image_desktop").show().siblings().hide();
    }
  }

  $(window).resize(function () {
    bigImage();
  });
  bigImage();
});
$(window).on('resize orientationchange', function () {
  overlapBlock('.main');
  overlapBlock('.modal');
  hero();
  spaceBlock('.main');
  spaceBlock('.modal');
  expandBlock();
});
$(".modal").scroll(function () {
  var modal_scrollTop = $('.modal').scrollTop(),
      url = window.location.href;
  localStorage.setItem('scrollpos', modal_scrollTop);
  localStorage.setItem('url', url);
});
$(window).on('load', function () {
  var scrollpos = localStorage.getItem('scrollpos'),
      url = localStorage.getItem('url');

  if (scrollpos && window.location.href === url) {
    $('.modal').scrollTop(scrollpos);
  }
}); // contact form 7 -------------------------------------

$('.wpcf7-form input:not(.wpcf7-submit), .wpcf7-form textarea').each(function () {
  // $(this).attr('autocomplete', 'off');
  if ($(this).val()) {
    $(this).parents(".item").not(".item--file").addClass("label-top");

    if ($(this).parents(".item").hasClass("item--date")) {
      $(this).addClass("visible-placeholder");
    }
  }
});
$('.wpcf7-form input, .wpcf7-form textarea').focus(function () {
  $(this).parents(".item").addClass("label-top");
});
$(".wpcf7-form textarea").each(function () {
  var $this = $(this),
      textareaHeight = $this.parents(".textarea-wrapper").find('.wpcf7-form-control').height();
  $(this).focus(function () {
    if (window.matchMedia("(max-width: 680px)").matches) {
      setTimeout(function () {
        var labelTopHeight = $this.parents(".label-top").find('label').height();
        $this.parents(".textarea-wrapper").find('.wpcf7-form-control').css('height', textareaHeight - labelTopHeight + 18);
        $this.parents(".textarea-wrapper").css('padding-top', labelTopHeight);
      }, 400);
    }
  });
});
$('.wpcf7-form input, .wpcf7-form textarea').blur(function () {
  if (!$(this).val()) {
    $(this).parents(".item").removeClass("label-top");

    if ($(this).parents(".item").hasClass("item--date")) {
      $(this).removeClass("visible-placeholder");
    }
  } else {
    if ($(this).parents(".item").hasClass("item--date")) {
      $(this).addClass("visible-placeholder");
    }
  }
}); // var divsHeightBeforeForm, index;
// setTimeout(function () {
//     divsHeightBeforeForm = 0;
//     index = 0;
//     $(".modal > div").each(function (i) {
//         if ($(this).hasClass("form-block")) {
//             index = i;
//         }
//     })
//     $(".modal > div").each(function (i) {
//
//         let divHeight = $(this).height();
//         if (i < index) {
//             divsHeightBeforeForm = divsHeightBeforeForm + divHeight;
//         }
//     })
// }, 1000)
// Stop background scrolling on IOS

function touchmoveStop() {
  $('.modal-opened').on('touchmove', function (e) {
    e.preventDefault();
    e.stopPropagation();
    return false;
  });
}

touchmoveStop();
var wpcf7Elm = document.querySelector('.wpcf7-form');

if (wpcf7Elm) {
  wpcf7Elm.addEventListener('wpcf7submit', function (event) {
    var file = $(".item--file");
    file.find("progress").attr('id', '');
    file.find(".loading").attr('id', '');
    file.find(".loading").find("span").attr('id', '');
    file.find(".info").attr('id', '');
    file.find(".uploaded").attr('id', '');
    $(this).find("input").each(function () {
      var $this = jQuery(this); // save this

      setTimeout(function () {
        $(".item--file").each(function () {
          if ($(this).find(".uploaded").find(".name").text() == '') {
            $(this).addClass("required-field-error");
          } else {
            $(this).removeClass("required-field-error");
          }
        });

        if ($this.hasClass("wpcf7-not-valid")) {
          $this.parents(".item").removeClass("activated");
          $this.parents(".item").addClass("not-valid"); // $('.modal').animate({scrollTop: divsHeightBeforeForm}, 800);

          var notValidPosTop;

          if ($this.parents('.item--file').hasClass('not-valid') || $this.parents('.item--file').hasClass('required-field-error')) {
            notValidPosTop = $('.item--file.not-valid').offset().top;
          } else {
            notValidPosTop = $this.parents('.wpcf7-form').offset().top;
          }

          var scrollTopModal = $('.modal').scrollTop();
          var dist = notValidPosTop - $('.modal').offset().top;
          $('.modal').animate({
            scrollTop: scrollTopModal + dist - 15
          }, 800);
          $this.parents(".item").find(".input-and-failed").show();
          $this.parents(".item").find(".failed").show();
        } else {
          $this.parents(".item").removeClass("not-valid");

          if ($this.val().length) {
            $this.parents(".item").addClass("activated");
          }
        }
      }, 10);
    });
    $(this).find("textarea").each(function () {
      var $this = jQuery(this); // save this

      setTimeout(function () {
        if ($this.hasClass("wpcf7-not-valid")) {} else {
          if ($this.val().length) {
            $this.parents(".item").addClass("activated");
          } else {
            $this.parents(".item").removeClass("activated");
          }
        }
      }, 10);
    });
  }, false);
  wpcf7Elm.addEventListener('wpcf7mailsent', function (event) {
    if (wpcf7Elm.closest('.send_form_once')) {
      var d = new Date();
      d.setTime(d.getTime() + 365 * 24 * 60 * 60 * 1000);
      var expires = "expires=" + d.toUTCString();
      document.cookie = 'cf7_sent_' + event.detail.contactFormId + '=true;' + expires + ";path=/";
    }

    $(this).find(".item").removeClass('label-top');
    $(this).find(".item").removeClass("activated");
    var currentFile = $('.item--file');
    currentFile.removeAttr('id');
    currentFile.find(".input-and-failed").hide();
    currentFile.find(".info").show();
    currentFile.find(".uploaded").hide();
    currentFile.find(".failed .name").text('');
    $('.item--file .clear-file').hide();
    var responsePosTop = $('.wpcf7-response-output').offset().top;
    var scrollTopModal = $('.modal').scrollTop();
    var dist = responsePosTop - $('.modal').offset().top; // $('.modal').animate({scrollTop: scrollTopModal + dist - 15}, 800);

    $('.modal').animate({
      scrollTop: scrollTopModal + 100
    }, 800);
  }, false);

  if (wpcf7Elm.closest('.send_form_once')) {
    $('.wpcf7 input[type="submit"]').on('click', function (e) {
      var formID = $(this).parents('.wpcf7').find('input[name=_wpcf7]').val();
      var formCookie = getCookie("cf7_sent_" + formID);

      if (formCookie) {
        e.preventDefault();
        $("#wpcf7-f" + formID + "-o1").find('.wpcf7-response-output').text(settings.job_detail_form_message_for_preventing_send_form);
        $("#wpcf7-f" + formID + "-o1").find('.wpcf7-response-output').show();
        $("#wpcf7-f" + formID + "-o1").find('.wpcf7-response-output').attr('style', 'display:block !important');
        $("#wpcf7-f" + formID + "-o1").find('.wpcf7-response-output').css('color', '#dc3232');
        var responsePosTop = $('.wpcf7-response-output').offset().top;
        var scrollTopModal = $('.modal').scrollTop();
        var dist = responsePosTop - $('.modal').offset().top; // $('.modal').animate({scrollTop: scrollTopModal + dist - 15}, 800);

        $('.modal').animate({
          scrollTop: scrollTopModal + 100
        }, 800);
      }
    });
  } // Restricts input for each element in the set of matched elements to the given inputFilter.


  (function ($) {
    $.fn.inputFilter = function (inputFilter) {
      return this.on("input keydown keyup mousedown mouseup select contextmenu drop", function () {
        if (inputFilter(this.value)) {
          this.oldValue = this.value;
          this.oldSelectionStart = this.selectionStart;
          this.oldSelectionEnd = this.selectionEnd;
        } else if (this.hasOwnProperty("oldValue")) {
          this.value = this.oldValue;
          this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
        } else {
          this.value = "";
        }
      });
    };
  })(jQuery); // $(".wpcf7-form-control.numeric").inputFilter(function (value) {
  //     return /^\d*$/.test(value);
  // });
  // $(document).on('keyup', '.numeric', function () {
  //     // skip for arrow keys
  //     if (event.which >= 37 && event.which <= 40) return;
  //
  //     // format number
  //     $(this).val(function (index, value) {
  //         return value
  //         // .replace(/\D/g, "")
  //             .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
  //             ;
  //     });
  // });


  $(document).ready(function () {
    $('.numeric').mask("#.##0.000", {
      reverse: true
    });
  });
  $(".wpcf7-form-control.tel").inputFilter(function (value) {
    return /^[0-9\-/\+\(\)\s]*$/i.test(value);
  });
}

$('.wpcf7-form .item--counter textarea').keyup(function () {
  var len = $(this).val().length;
  $(this).parents(".item").find(".counter").children("span").text(len);
  var $this = $(this);

  if ($this.scrollTop() == 0) {
    $this.parents(".item").removeClass("scrolled-bottom");
  }
});
var formTextarea = $(".wpcf7-form textarea");
formTextarea.scroll(function () {
  var bottom = formTextarea.prop('scrollHeight') - formTextarea.height();
  var $this = $(this); // console.log($this.scrollTop());
  // console.log(bottom);

  if (bottom - $this.scrollTop() < 50) {
    $this.parents(".item").addClass("scrolled-bottom");
  } else {
    $this.parents(".item").removeClass("scrolled-bottom");
  }
});

function _(el) {
  return document.getElementById(el);
} // for file upload


function uploadFile(i) {
  var file = _("upload-" + i).files[0];

  var formdata = new FormData();
  formdata.append("upload-" + i, file);
  var ajax = new XMLHttpRequest();
  ajax.upload.addEventListener("progress", progressHandler, false);
  ajax.addEventListener("load", completeHandler, false); // ajax.addEventListener("error", errorHandler1, false);
  // ajax.addEventListener("abort", abortHandler1, false);

  ajax.open("POST", settings.theme_url + "/file_upload_parsers.php"); // http://www.developphp.com/video/JavaScript/File-Upload-Progress-Bar-Meter-Tutorial-Ajax-PHP
  //use file_upload_parser.php from above url

  ajax.send(formdata);
}

function progressHandler(event) {
  var percent = event.loaded / event.total * 100;
  _("current-progress").value = Math.round(percent);
  _("current-status").innerHTML = "Datei wird hochgeladen...";
  _("current-info").style.display = 'none';
  _("current-loading").style.display = 'block';
  $('.item--file').css('pointer-events', 'none');
}

function completeHandler(event) {
  _("current-loading").style.display = 'none';
  _("current-uploaded").style.display = 'flex';
  _("current-progress").value = 0; //wil clear progress bar after successful upload

  _("current-upload-file").id = 'uploaded';
  $('.item--file').css('pointer-events', 'visible');
} // function errorHandler1(event) {
//     _("current-status-1").innerHTML = "Upload Failed";
// }
// function errorHandler2(event) {
//     _("current-status-2").innerHTML = "Upload Failed";
// }


$(".wpcf7-form .item--file .wpcf7-file").each(function (j) {
  $(this).change(function (e) {
    var i = j + 1;
    var fileName = e.target.files[0].name;
    var fileSizeBytes = e.target.files[0].size;
    var file = $(".item--file");
    var currentFile = $(this).parents(".item--file");
    var fileSizeMegaBytes = fileSizeBytes / 1024 / 1024;
    console.log(fileSizeMegaBytes);
    currentFile.removeClass("not-valid");
    currentFile.removeClass("required-field-error"); // file.attr('id', '');

    file.find("progress").attr('id', '');
    file.find(".loading").attr('id', '');
    file.find(".loading").find("span").attr('id', '');
    file.find(".info").attr('id', '');
    file.find(".uploaded").attr('id', '');
    currentFile.attr('id', 'current-upload-file');
    currentFile.find("progress").attr('id', 'current-progress');
    currentFile.find(".loading").attr('id', 'current-loading');
    currentFile.find(".loading").find("span").attr('id', 'current-status');
    currentFile.find(".info").attr('id', 'current-info');
    currentFile.find(".uploaded").attr('id', 'current-uploaded');
    currentFile.find(".clear-file").show();
    currentFile.find(".uploaded").hide();
    currentFile.find(".input-and-failed").hide();
    currentFile.find(".uploaded").children(".name").text(fileName);
    currentFile.find(".failed").children(".name").text(fileName);
    uploadFile(i);
  });
});
$(".clear-file").on('click', function () {
  $(this).hide();
  var currentItem = $(this).parents(".item");
  currentItem.attr("id", "");
  currentItem.removeClass("not-valid");
  currentItem.find("input").val('');
  currentItem.find('.input-and-failed').hide();
  currentItem.find('.input-and-failed').find(".name").text("");
  currentItem.find('.info').show();
  currentItem.find('.failed').hide();
  currentItem.find('.uploaded').hide();
  currentItem.find('.uploaded').find(".name").text("");
  currentItem.find('.loading').hide();
}); //cf 7 changes for date input

$(function () {
  var now = new Date();
  var day = ("0" + now.getDate()).slice(-2);
  var month = ("0" + (now.getMonth() + 1)).slice(-2);
  var today = now.getFullYear() + "-" + month + "-" + day;
  $('input[type=date]').attr("min", today);
}); // modal

function closeModal() {
  $(".modal-opened .close").click(function (e) {
    e.preventDefault();
    $('body').removeClass('modal-opened');
    $('html').removeClass('modal-opened');
    window.history.pushState(null, null, window.location.pathname);
    $('.modal').css('opacity', '0');
    $('.modal').scrollTop(0);
    $('.main').css('opacity', '1');

    if ($(this).hasClass('reload-page')) {// location.reload();
    }
  });
}

function toTop() {
  $('.to_top').click(function (e) {
    e.preventDefault();
    $('.modal').animate({
      scrollTop: 0
    }, 'slow');
    return false;
  });
}

$(document).ready(function () {
  toTop();
  closeModal();
});
$(document).on('click', '.open-modal, .modal-page a', function (e) {
  e.preventDefault();
  var page_id, page_slug, page_type;

  if ($(e.target).parent('li').hasClass('modal-page')) {
    var theClass = $(this).parent('li').attr("class").match(/id[\w-]*\b/);
    page_id = theClass[0].replace("id-", "");
    var url = $(this).attr('href'),
        urlParts = url.split("/");
    page_slug = urlParts[urlParts.length - 2];
    page_type = 'seite';
  } else {
    page_id = $(this).data('page_id');
    page_slug = $(this).data('page_slug');
    page_type = $(this).data('page_type');
  }

  var $this = $(this);
  $.ajax({
    url: settings.ajax_url,
    type: 'post',
    data: {
      action: 'modal',
      page_id: page_id,
      page_type: page_type
    },
    success: function success(response) {
      $('.modal').html(response);
      $('.modal').css('opacity', '1');
      $('body').addClass('modal-opened');
      touchmoveStop();
      closeModal();
      toTop();
      $('.modal').scrollTop(0);
      window.history.pushState({}, '', '?' + page_type + '=' + page_slug);
      slickSliders();
      overlapBlock('.modal');
      spaceBlock('.main');
      spaceBlock('.modal');
      hero();
    }
  });
});
$(document).on('click', '.navigate-post', function (e) {
  e.preventDefault();
  var page_id = $(this).data('page_id');
  var page_slug = $(this).data('page_slug');
  var page_type = $(this).data('page_type');
  $.ajax({
    url: settings.ajax_url,
    type: 'post',
    data: {
      action: 'modal',
      page_id: page_id,
      page_type: page_type
    },
    success: function success(response) {
      $('.modal').html(response);
      $('.modal').css('opacity', '1');
      closeModal();
      toTop();
      touchmoveStop();
      $('.modal').scrollTop(0);
      window.history.pushState({}, '', '?' + page_type + '=' + page_slug);
      slickSliders();
      overlapBlock('.modal');
      spaceBlock('.main');
      spaceBlock('.modal');
    }
  });
});
$(window).bind("mousewheel", function () {
  $("html, body, .modal").stop();
});
$(document).ready(function ($) {
  if (window.history && window.history.pushState) {
    $(window).on('popstate', function (e) {
      var previusUrl = location.href;

      if (previusUrl.indexOf('?projekt=') > -1 || previusUrl.indexOf('?seite=') > -1 || previusUrl.indexOf('?artikel=') > -1) {
        window.location.reload();
      } else {
        $('html, body').removeClass('modal-opened');
        $('.modal').css('opacity', '0');
      }
    });
  }
});